import { useState } from 'react';
import { Tag, Typography, Flex, Dropdown, Tree, Button, Tooltip } from 'antd';
import { PlusIcon, XIcon } from '@phosphor-icons/react';
import styled from '@emotion/styled';
import { handleTreeCheck } from './utils';

const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const AddTagButton = styled(Button)`
  padding: 0 16px;
  height: 24px;
  border: none;
  background: none;
  color: #3132eb;
  font-size: 12px;
  font-weight: 500;
  box-shadow: none;
  width: min-content;

  &:hover {
    color: #171717;
    background: #f4f4f4;
  }
`;

interface IAcceptedTagsProps {
  tags: Array<string>;
  closable: boolean;
  treeData: Array<any>;
  onCloseTag?: (tag: string) => void;
  onTagChange?: (checked: Array<string>) => void;
  closeTooltip?: string;
  isLoading?: boolean;
}

const AcceptedTags = ({
  tags,
  closable,
  treeData,
  onCloseTag,
  onTagChange,
  closeTooltip,
  isLoading,
}: IAcceptedTagsProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div>
      <Typography.Text style={{ fontWeight: 400, fontSize: 12 }}>Accepted Tags</Typography.Text>
      <Flex vertical gap={4}>
        <TagsWrapper>
          {tags.map(tag => (
            <Tag
              key={tag}
              color="green"
              closable={closable}
              closeIcon={
                closeTooltip ? (
                  <Tooltip title={closeTooltip}>
                    <XIcon />
                  </Tooltip>
                ) : (
                  <XIcon />
                )
              }
              onClose={() => onCloseTag?.(tag)}
              style={{
                color: '#171717',
                fontWeight: 700,
                borderRadius: 20,
                opacity: 0.8,
                letterSpacing: 0.5,
                textTransform: 'uppercase',
              }}
            >
              {tag}
            </Tag>
          ))}
        </TagsWrapper>
        {closable && (
          <Dropdown
            open={dropdownOpen}
            onOpenChange={setDropdownOpen}
            popupRender={() => (
              <div
                style={{
                  padding: 8,
                  background: '#fff',
                  borderRadius: 20,
                  boxShadow: '0px 4px 34px 0px rgba(0, 0, 0, 0.1)',
                  maxHeight: 300,
                  overflowY: isLoading ? 'hidden' : 'auto',
                  position: 'relative',
                }}
              >
                {isLoading && (
                  <div
                    style={{
                      position: 'absolute',
                      inset: 0,
                      zIndex: 1,
                      background: 'rgba(255, 255, 255, 0.8)',
                      cursor: 'progress',
                    }}
                  ></div>
                )}
                <Tree
                  checkable
                  treeData={treeData}
                  checkedKeys={tags}
                  onCheck={checked => {
                    const result = handleTreeCheck(checked, treeData);
                    onTagChange?.(result);
                  }}
                  defaultExpandAll
                />
              </div>
            )}
            trigger={['click']}
            arrow
          >
            <AddTagButton
              type="text"
              icon={<PlusIcon />}
              onClick={event => {
                setDropdownOpen(true);
                event.stopPropagation();
              }}
            >
              ADD TAGS
            </AddTagButton>
          </Dropdown>
        )}
      </Flex>
    </div>
  );
};

export default AcceptedTags;
